<template>
    <Header
        elements="7"
        current="3"
    ></Header>
    <NumberPageBlock
        form_type="SOUE"
        part_url="statement-of-use-extension"
        part_url_next="step-2"
        deadline_word="Upcoming Deadline"
    ></NumberPageBlock>
</template>

<script>
import Header from '@/components/Header-Short-New.vue'
import NumberPageBlock from '@/components/blocks/NumberPageBlock.vue'
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        NumberPageBlock
    },
    data() {
        return {}
    },
    mounted() {
        to_top()
        this.$store.commit('header/setTotal', 0)
    }
}
</script>

